module.exports = __webpack_public_path__ + "static/media/bootstrap_start.fbd5aa96.png";